import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

type Step = 1 | 2 | 3 | 4;

export default function Onboarding() {
  const nav = useNavigate();
  const [step, setStep] = useState<Step>(1);
  const [connections, setConnections] = useState({ shopify: true, meta: false, pinterest: false });

  function connect(name: 'meta' | 'pinterest') {
    setTimeout(() => setConnections((c) => ({ ...c, [name]: true })), 600);
  }

  return (
    <div style={{ maxWidth: 580, margin: '40px auto' }}>
      <div style={{ marginBottom: 20, display: 'flex', gap: 6 }}>
        {[1, 2, 3, 4].map((s) => (
          <div
            key={s}
            style={{
              flex: 1,
              height: 3,
              borderRadius: 2,
              background: s <= step ? 'var(--brand)' : 'var(--border)',
            }}
          />
        ))}
      </div>

      {step === 1 && (
        <div className="card card-padded">
          <h2 className="page-title">Welcome to ScaleAds AI.</h2>
          <p className="page-sub">Let's turn your store into a self-scaling ad machine.</p>
          <p style={{ color: 'var(--text-sub)', fontSize: 13, marginBottom: 20 }}>
            We'll take ~4 minutes to connect your ad accounts and launch your first campaign.
          </p>
          <button className="btn btn-primary" onClick={() => setStep(2)}>
            Continue
          </button>
        </div>
      )}

      {step === 2 && (
        <div className="card card-padded">
          <h2 className="page-title">Connect Meta Ads</h2>
          <p className="page-sub">Required — we use this for Facebook + Instagram campaigns.</p>
          <div style={{ background: 'var(--surface-2)', padding: 14, borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
            <b>Permissions we'll request:</b>
            <ul style={{ margin: '8px 0 0 18px', padding: 0, color: 'var(--text-sub)' }}>
              <li>ads_management (create and read campaigns)</li>
              <li>business_management</li>
              <li>read_insights</li>
            </ul>
          </div>
          {connections.meta ? (
            <div style={{ color: 'var(--success)', marginBottom: 16, fontWeight: 500 }}>
              ✓ Meta connected
            </div>
          ) : (
            <button className="btn btn-primary" onClick={() => connect('meta')}>
              Connect Meta
            </button>
          )}
          {connections.meta && (
            <button className="btn" style={{ marginLeft: 8 }} onClick={() => setStep(3)}>
              Continue →
            </button>
          )}
        </div>
      )}

      {step === 3 && (
        <div className="card card-padded">
          <h2 className="page-title">Connect Pinterest (optional)</h2>
          <p className="page-sub">Recommended for visual products — works best for evergreen traffic.</p>
          {connections.pinterest ? (
            <div style={{ color: 'var(--success)', marginBottom: 16, fontWeight: 500 }}>
              ✓ Pinterest connected
            </div>
          ) : (
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary" onClick={() => connect('pinterest')}>
                Connect Pinterest
              </button>
              <button className="btn" onClick={() => setStep(4)}>
                Skip for now
              </button>
            </div>
          )}
          {connections.pinterest && (
            <button className="btn" style={{ marginLeft: 0, marginTop: 12 }} onClick={() => setStep(4)}>
              Continue →
            </button>
          )}
        </div>
      )}

      {step === 4 && (
        <div className="card card-padded" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>🚀</div>
          <h2 className="page-title">You're ready.</h2>
          <p className="page-sub">Launch your first campaign in one click.</p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 16 }}>
            <button className="btn btn-primary" onClick={() => nav('/campaigns/new')}>
              Launch your first campaign
            </button>
            <button className="btn" onClick={() => nav('/')}>
              Go to dashboard
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
